import { render } from "./PlansComparison.vue?vue&type=template&id=0322c649&scoped=true"
import script from "./PlansComparison.vue?vue&type=script&lang=js"
export * from "./PlansComparison.vue?vue&type=script&lang=js"

import "./PlansComparison.vue?vue&type=style&index=0&id=0322c649&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0322c649"]])

export default __exports__